import "./error.scss";
import { useNavigate } from "react-router-dom";
import error from "./images/error.svg";

const Error = () => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/allvacancies");
    };

    return (
        <div className="errorpage">
            <img src={error} className="errorpage-img" alt="" />
            <p className="errorpage-title">Что-то пошло не так...</p>
            <button className="errorpage-btn" onClick={handleClick}>
                Перейти на главную
            </button>
        </div>
    );
};

export default Error;
